import { render, staticRenderFns } from "./quickInfo.vue?vue&type=template&id=1640514c&"
import script from "./quickInfo.vue?vue&type=script&lang=ts&"
export * from "./quickInfo.vue?vue&type=script&lang=ts&"
import style0 from "./quickInfo.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports